import {ChangeDetectionStrategy, Component} from '@angular/core';
import {FieldType, FormlyModule} from '@ngx-formly/core';
import {NbCheckboxModule} from "@nebular/theme";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
    templateUrl: './checkbox-property.component.html',
    imports: [
        NbCheckboxModule,
        ReactiveFormsModule,
        FormlyModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CheckboxPropertyComponent extends FieldType {
}
